import EdgeworthIcon from '@office-start/edgeworth-icon';
import React, { useMemo } from 'react';
import { ActivityFilterKey, ActivityFilterKeyToIconMap, } from '../models/ActivityFilters';
import { DateFilterKey } from '../models/DateFilters';
import { FileFilterKey, FileFilterToIconMap } from '../models/FileFilters';
import { FilterType } from '../models/Filters';
import styles from '../views/BaseEdgeworthControl.module.scss';
import { useFilterNameMap } from './useFilterNameMap';
function getPillFromFilterKey(filterKey, filterNameMap, filterKeyToIconMap, iconElement, filterType) {
    var _a;
    var style = {
        height: '24px',
    };
    var filterName = filterNameMap.get(filterKey);
    var filterIcon = iconElement || ((_a = filterKeyToIconMap === null || filterKeyToIconMap === void 0 ? void 0 : filterKeyToIconMap.get(filterKey)) !== null && _a !== void 0 ? _a : undefined);
    return {
        id: filterKey,
        title: filterName,
        iconElement: filterIcon,
        isRemovable: true,
        isActive: false,
        isStatic: true,
        filterType: filterType,
        style: style,
        ariaLabel: filterName,
        disableRemoveFocus: true,
    };
}
export function usePillFiltersMap(locResources) {
    var filterNameMap = useFilterNameMap(locResources);
    return useMemo(function () {
        var pillFilterMap = new Map();
        Object.values(FileFilterKey).forEach(function (filterKey) {
            pillFilterMap.set(filterKey, getPillFromFilterKey(filterKey, filterNameMap, FileFilterToIconMap, undefined, FilterType.FileType));
        });
        Object.values(ActivityFilterKey).forEach(function (filterKey) {
            pillFilterMap.set(filterKey, getPillFromFilterKey(filterKey, filterNameMap, ActivityFilterKeyToIconMap, undefined, FilterType.Activity));
        });
        var calendarEmptyIcon = (React.createElement("div", { className: styles['pill-filter-icon'] },
            React.createElement(EdgeworthIcon, { iconName: "CalendarEmptyIcon" })));
        Object.values(DateFilterKey).forEach(function (filterKey) {
            pillFilterMap.set(filterKey, getPillFromFilterKey(filterKey, filterNameMap, null, calendarEmptyIcon, FilterType.Date));
        });
        return pillFilterMap;
    }, [filterNameMap]);
}
//# sourceMappingURL=usePillFiltersMap.js.map